export default "__VITE_ASSET__CeSndAB5__"